import { useState } from "react";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const BackupButton = () => {
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const res = await api.get("/admin/backup", { responseType: "blob", timeout: 300000 });
      const name = res.headers["content-disposition"]?.match(/filename="(.+)"/)?.[1] || "backup-berita.zip";
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = name; a.click();
      URL.revokeObjectURL(url);
      toast.success("Backup berhasil diunduh");
    } catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };

  return (
    <Button variant="outline" onClick={download} disabled={busy} data-testid="backup-download-button">
      <Download size={16} /> {busy ? "Menyiapkan..." : "Unduh Backup"}
    </Button>
  );
};
